import { schema } from 'normalizr';

export const assetsAudiosSchema = new schema.Entity(
  'audios', 
  {},
  { idAttribute: 'guid' }
);